/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppServer } from "../../app";
import { DOC_TYPES } from "../../blueprints";
import { ILogger } from "../../logger";
import { GENERIC_RESOURCE_PERMISSIONS, RESOURCE_PERMISSIONS } from "../../registries";
import { RESOURCE_TYPES } from "../IResource";
import { IReadmeResourceProps, IReadmeResourceType } from "./IReadmeResource";

export class ReadmeResourceV1 implements IReadmeResourceType {
	public get permissions(): RESOURCE_PERMISSIONS[] {
		return GENERIC_RESOURCE_PERMISSIONS;
	}

	public get name(): string {
		return DOC_TYPES.README_V1;
	}

	public get category(): string {
		return RESOURCE_TYPES.README;
	}

	public get statsName(): string {
		return "readmes";
	}

	protected logger: ILogger;

	public constructor(protected app: IAppServer) {
		this.logger = this.app.get("logger").facility("resource-readme-v1");
	}

	public setup(resource: IReadmeResourceProps): IReadmeResourceProps {
		resource.resourceType = RESOURCE_TYPES.README;
		resource.parsingDetails.isRegistered = true;

		return resource;
	}

	public async scan(resource: IReadmeResourceProps): Promise<IReadmeResourceProps> {
		this.logger.debug(`Scan readme '${resource.uri}'.`);
		return resource;
	}

	public async parse(resource: IReadmeResourceProps): Promise<IReadmeResourceProps> {
		return resource;
	}

	public getDependenciesToReload(): string[] {
		return [];
	}
}
